import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { mergeApplicationConfig } from '@angular/core';
import { AuthService, provideAuth0 } from '@auth0/auth0-angular';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { of } from 'rxjs';

const isCypress = typeof window !== 'undefined' && !!(window as any).Cypress;

// Validate Auth0 configuration (skip in Cypress, which uses a lightweight mock).
if (!isCypress && (!environment?.auth0?.domain || !environment?.auth0?.clientId)) {
  console.error('Auth0 configuration missing. Please check your environment files.');
  console.error('Required values:');
  console.error('- environment.auth0.domain');
  console.error('- environment.auth0.clientId');
  throw new Error('Auth0 domain and client ID must be set in environment.*.ts');
}

const authProviders = isCypress
  ? [
      {
        provide: AuthService,
        useValue: {
          isLoading$: of(false),
          isAuthenticated$: of(true),
          user$: of({
            sub: 'cypress|user',
            name: 'Cypress User',
            email: 'cypress@example.com',
            email_verified: true,
            picture: '',
          }),
          appState$: of(null),
          handleRedirectCallback: () => of({ appState: null }),
          loginWithRedirect: () => of(void 0),
          getAccessTokenSilently: () => of('cypress-access-token'),
          logout: () => of(void 0),
        },
      },
    ]
  : [
      provideAuth0({
        domain: environment.auth0.domain,
        clientId: environment.auth0.clientId,
        // Persist auth state across full page reloads.
        // Note: localstorage increases impact if your app ever has an XSS bug.
        cacheLocation: 'localstorage',
        // Prefer refresh token rotation over silent auth in an iframe.
        useRefreshTokens: true,
        authorizationParams: {
          redirect_uri: window.location.origin,
          // Needed for refresh tokens in SPAs.
          scope: 'openid profile email offline_access',
          // Required to mint an Access Token for your backend API.
          audience: environment.auth0.audience,
        },
      }),
    ];

const auth0Config = mergeApplicationConfig(appConfig, { providers: authProviders });

bootstrapApplication(AppComponent, auth0Config)
  .catch((err) => console.error(err));
